module.exports = __webpack_public_path__ + "static/media/05_digginglight.1af77096.jpg";